// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assemblies .sidebar-view{width:90%;height:100vh}.assemblies .sidebar-view .nav-list{height:100vh}\n", ""]);
// Exports
module.exports = exports;
